// packages/ui/src/help/helpPages.ts
//
// In-app help-page manifest for the header Help menu. The slugs mirror the
// website's HELP_PAGES (apps/website/app/help/_data/manifest.ts) — those slugs
// are a documented public contract the desktop app deep-links into. Groups are
// imposed here for the menu layout (the website manifest has no groups).
export const HELP_URL_BASE = 'https://slateeditor.com/help';

export const HELP_GROUPS = ['Get started', 'Write & edit', 'Organize', 'Navigate', 'Tools'] as const;
export type HelpGroup = (typeof HELP_GROUPS)[number];

export interface HelpPage {
  /** Path after /help; '' is the landing page. Public contract (see website manifest). */
  slug: string;
  title: string;
  group: HelpGroup;
}

export const HELP_PAGES: HelpPage[] = [
  { slug: '', title: 'Getting Started', group: 'Get started' },
  { slug: 'views', title: 'The Three Views', group: 'Get started' },
  { slug: 'editing', title: 'Editing and Formatting', group: 'Write & edit' },
  { slug: 'rich-content', title: 'Rich Content', group: 'Write & edit' },
  { slug: 'code', title: 'Code and Config Files', group: 'Write & edit' },
  { slug: 'appearance', title: 'Themes and Appearance', group: 'Write & edit' },
  { slug: 'files', title: 'Files and Saving', group: 'Organize' },
  { slug: 'workspace', title: 'Workspace and Sidebar', group: 'Organize' },
  { slug: 'tabs', title: 'Tabs and Documents', group: 'Organize' },
  { slug: 'navigation', title: 'Navigation and Outline', group: 'Navigate' },
  { slug: 'palette', title: 'Command Palette', group: 'Navigate' },
  { slug: 'shortcuts', title: 'Keyboard Shortcuts', group: 'Navigate' },
  { slug: 'platforms', title: 'Platforms', group: 'Navigate' },
  { slug: 'troubleshooting', title: 'Troubleshooting', group: 'Navigate' },
  { slug: 'terminal', title: 'Integrated Terminal', group: 'Tools' },
  { slug: 'cli', title: 'The slate Command', group: 'Tools' },
];

export function helpUrl(slug: string): string {
  return slug ? `${HELP_URL_BASE}/${slug}` : HELP_URL_BASE;
}

export function helpPagesByGroup(): { group: HelpGroup; pages: HelpPage[] }[] {
  return HELP_GROUPS.map((group) => ({
    group,
    pages: HELP_PAGES.filter((p) => p.group === group),
  })).filter((g) => g.pages.length > 0);
}
